<script setup>
import { onMounted, ref } from 'vue'

import { HTextfield } from '@/components/shared/atoms'

defineProps({
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['input'])
const autofocus = ref(false)
const token = ref(null)

onMounted(() => {
  setTimeout(() => (autofocus.value = true), 300)
})
const handleInput = token => {
  emit('input', token)
}
</script>

<template>
  <div class="infoBox">
    <HTextfield
      class="input"
      :value="token"
      :auto-focus="autofocus"
      :disabled="loading"
      label="Insira o Token Bird ID para renová-la"
      placeholder="000000"
      type="number"
      @update:value="handleInput"
    />
  </div>
</template>

<style lang="scss" scoped>
.infoBox {
  line-height: var(--gl-line-height-xxs);

  /* Chrome, Safari, Edge, Opera */
  ::v-deep(input)::-webkit-outer-spin-button,
  ::v-deep(input)::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  ::v-deep(input)[type='number'] {
    -moz-appearance: textfield;
  }
}

.input {
  width: 255px;
}
</style>
